import { create } from 'zustand';

type PageRefetchEntry = {
	pathname: string;
	fn: () => unknown;
} | null;
interface ISiderToggleMenuModal {
	isOpen: boolean;
	isFullPageLoader: boolean;
	refetchName: string | string[];
	pageRefetch: PageRefetchEntry;
	setRefetchName: (state: string | string[]) => void;
	setPageRefetch: (entry: PageRefetchEntry) => void;
	setModal: (state: boolean) => void;
	setFullPageLoader: (state: boolean) => void;
}
const initialState = {
	isOpen: false,
	isFullPageLoader: false,
	refetchName: 'all',
	pageRefetch: null,
};

export const useSiderToggleMenu = create<ISiderToggleMenuModal>((set) => ({
	...initialState,
	setModal: (item: boolean): void => set((state) => ({ ...state, isOpen: item })),
	setFullPageLoader: (item: boolean): void => set((state) => ({ ...state, isFullPageLoader: item })),
	setRefetchName: (item: string | string[]): void =>
		set((state) => ({ ...state, refetchName: Array.isArray(item) ? [...item] : item })),
	setPageRefetch: (entry: PageRefetchEntry): void => set((state) => ({ ...state, pageRefetch: entry })),
}));
